<template>
  <div class="grey-box">
    <div class="grey-box__half">
      <slot name="left"></slot>
    </div>
    <div class="grey-box__divider"></div>
    <div class="grey-box__half">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<style scoped>
.grey-box{
  background: #FBFBFB;
  border: 1px solid #C8C8C8;
  padding: 16px;
  display: flex;
  gap: 32px;
}

.grey-box__half{
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.grey-box__divider{
  width: 1px;
  background: #C8C8C8;
}

@media(max-width: 600px){
  .grey-box{
    flex-direction: column;
  }
  .grey-box__divider{
    width: 100%;
    height: 1px;
  }
  .grey-box__half{
    width: 100%;
  }
}
</style>

<script>
export default {
  components: {},
  props: {},
  data: () => ({
  }),
}
</script>
